// as the design doesn't follow nexus design it's not possible to use nexus component here without changes
import { ListItem } from '@nexus/lib-react/dist/core/List/ListItem';
import { Paragraph3 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import { progressiveLoading } from '../../styles/animations';
import styled from '../../../theme/styled';

const List = styled.ul`
  display: flex;
  flex-direction: column;
  font-size: ${({ theme }) => theme.fontSizes[14]};
  padding: 0;
  margin: 0;
`;

const LItem = styled(ListItem)`
  div {
    display: flex;
    align-content: space-between;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    min-height: 42px;
  }

  &:last-of-type {
    border-bottom: none;
  }
`;

const ListItemHeader = styled(Paragraph3)`
  color: ${({ theme }) => theme.colors['text-global-secondary']};
  font-size: ${({ theme }) => theme.fontSizes[14]};
  font-weight: ${({ theme }) => theme.fontWeights[400]};
`;

const ListItemValue = styled(Paragraph3)<{ isImportant?: boolean }>`
  color: ${({ theme }) => theme.colors['text-brand-primary']};
  font-size: ${({ theme }) => theme.fontSizes[14]};
  font-weight: ${props =>
    props.isImportant
      ? ({ theme }) => theme.fontWeights[500]
      : ({ theme }) => theme.fontWeights[400]};

  &:empty {
    padding: 8px;
    margin: 5px 12px 0 0;

    ${progressiveLoading()}
  }
`;

export default {
  List,
  LItem,
  ListItemHeader,
  ListItemValue,
};
